import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminNotLoggedInComponent } from './admin-not-logged-in/admin-not-logged-in.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslateModule.forChild()],
  declarations: [AdminNotLoggedInComponent, PageNotFoundComponent],
})
export class ErrorPagesModule {}
